export default "__VITE_ASSET__Dfe3DO0z__"